// Note: new Adapty API is naming this placementId that is used to fetch the paywall
export const PAYWALLS = {
  paywall_downgrade: 'paywall_downgrade',
  paywall_geo_notifications: 'paywall_geo_notifications',
  paywall_settings: 'paywall_settings',
  paywall_stats: 'paywall_stats',
  paywall_time_notifications: 'paywall_time_notifications',
  paywall_tests_phq_9: 'paywall_tests_phq_9',
  paywall_tests_gad_7: 'paywall_tests_gad_7',
  paywall_meditations: 'paywall_meditations',
  paywall_worry_trees: 'paywall_worry_trees',
  paywall_downward_arrows: 'paywall_downward_arrows',
  paywall_behavior_experiments: 'paywall_behavior_experiments',
  paywall_exposures: 'paywall_exposures',
  paywall_ai_image_generation: 'paywall_ai_image_generation',
  // E47 · the mode history beyond the free 7 days ("See your whole history with Premium", placement modes)
  paywall_modes: 'paywall_modes',
};

/**
 * E34 block 5a · Q-b5-1 B (2026-09-30) — every paid course has its OWN Adapty placement (its paywall carries the
 * course's one-off store product and its own description). The placement id is named in the course's access rule
 * (Backoffice → Course library → Access rule, `adaptyPlacementId`); the phone opens THAT placement, reads the
 * store product and its localized price from it, then `makePurchase`. Configured in the Adapty dashboard by the
 * founder. Deliberately NOT in `PAYWALLS`: those are the premium paywalls the subscription screen reports.
 *
 * The suggestion the access-rule field shows: `paywall_course_<courseKey>`, the key's non-alphanumerics as
 * underscores (a library id such as `lib-pw-activate-8w` → `paywall_course_lib_pw_activate_8w`).
 */
export const suggestedCoursePlacementId = (pathwayId: string): string =>
  `paywall_course_${pathwayId.replace(/[^A-Za-z0-9]+/g, '_')}`;

export const PRODUCTS = {
  client_year_999: 'client_year_999',
  client_6months_999: 'client_6months_999',
  client_monthly_999: 'client_monthly_999',
};

// Note: undefined is free
export const ACCESS_LEVELS = {
  premium: 'premium',
  premium_practice: 'premium_practice',
} as const;

// Note: for some reason we are not getting them for Android
// and overall it seems to be unerliable, so adding a manual mapping
export const subscriptionPeiods = {
  [PRODUCTS.client_monthly_999]: {
    unit: 'month',
    numberOfUnits: 1,
  },

  [PRODUCTS.client_6months_999]: {
    unit: 'month',
    numberOfUnits: 6,
  },

  [PRODUCTS.client_year_999]: {
    unit: 'year',
    numberOfUnits: 1,
  },
};

export const FREE_SUBSCRIPTION_APPS = 5;
